import React from 'react';
import { useParams } from 'react-router-dom';
import { AdminReportingContainer } from '@/components/Organization/Locations/Admin/AdminReportingContainer';
import { PageTitle } from '@/components/common/PageTitle/PageTitle';
import { RouteContentWrapper } from '../../styles';

export const AdminReportingOrganizationRoute = () => {
    const { organizationId } = useParams<{ organizationId: string }>();

    return (
        <RouteContentWrapper>
            <PageTitle title="Reporting" />
            <AdminReportingContainer organizationId={organizationId ? parseInt(organizationId) : null} />
        </RouteContentWrapper>
    );
};
